module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAPCAYAAADQ4S5JAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADtSURBVHgBlVHBDYMwDEwCD550g3aDdIN0hE7QfBA8MwpPEJ90gqoTFCYoI2SD5gkPRJ0qkSCICk6y7JzPcWJj5EEIEfd9z8Zx1EVR1H4eTw9JklBCyAtjHFtKDcNwraqqdRriAs55HATBA8TPKIoOQJ3AGsOZrk4XugBEFNwR7JLnuQav4RIB/KfrOpOrZx2sGMG7lSOklHqa+/0hyzIG/mZJE0s0B7e3K7B7aIXcE/hg1jcE7cRaQQ17aDcVwFhb+PilLMszspP5W2A2PIljPx+iJViapm/oZArplgLzLIpWsHtKpoNCy2WtQX0BSrdIt1X3AsMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/pages/administratorSystemAdministrator/assets/Vector(2).png
// module id = 3Sus
// module chunks = 1